import DatamodelPage from "@/platform/components/datamodel/datamodel-page";

const AlertCaseDetails = () => {
    return (
    <div className="alertcase-page">
      <DatamodelPage datamodelType="alertcase" />  
    </div>
  );
};

export default AlertCaseDetails;